import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    ACT_LIST, ACT_ADD, ACT_GET, ACT_EDIT, ACT_CALENDAR,
    ACT_DESTINATIONS, ACT_SUPPLIERS, ACT_TASK_TYPES, ACT_ENGINEERS, ACT_DETAIL,
    ACT_DETAIL_LIST, ACT_DETAIL_ADD, ACT_TASK_STATUS, ACT_DELIVERY_PLAN_DETAILS,
    ACT_MESSAGE_LIST, ACT_MESSAGE_READ, ACT_GENERATE_EQUIPMENT_UNIT
} from "../actions";

import {
    ActListSuccess, ActListError, ActAddSuccess, ActAddError,
    ActGetSuccess, ActGetError, ActEditSuccess, ActEditError,
    ActCalendarSuccess, ActCalendarError,
    ActDestinationsSuccess, ActDestinationsError, ActSuppliersSuccess, ActSuppliersError,
    ActTaskTypesSuccess, ActTaskTypesError, ActEngineersSuccess, ActEngineersError,
    ActDetailSuccess, ActDetailError,
    ActDetailChatListSuccess, ActDetailChatListError,
    ActDetailChatAddSuccess, ActDetailChatAddError,
    ActTaskStatusSuccess, ActTaskStatusError,
    ActDeliveryPlanDetailsSuccess, ActDeliveryPlanDetailsError,
    ActMessageListSuccess, ActMessageListError,
    ActMessageReadSuccess, ActMessageReadError,
    ActGenerateEquipmentUnitSuccess, ActGenerateEquipmentUnitError
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
        }, reject);
    });
}

const fetchApi = async (endpoint, payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + endpoint, {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).then(d => d).catch(err => console.log(err));
    return { "data": response };
};

export function* watchActList() { yield takeEvery(ACT_LIST, onActList); }
export function* watchActAdd() { yield takeLatest(ACT_ADD, onActAdd); }
export function* watchActGet() { yield takeLatest(ACT_GET, onActGet); }
export function* watchActEdit() { yield takeLatest(ACT_EDIT, onActEdit); }
export function* watchActCalendar() { yield takeEvery(ACT_CALENDAR, onActCalendar); }
export function* watchActDestinations() { yield takeEvery(ACT_DESTINATIONS, onActDestinations); }
export function* watchActSuppliers() { yield takeEvery(ACT_SUPPLIERS, onActSuppliers); }
export function* watchActTaskTypes() { yield takeEvery(ACT_TASK_TYPES, onActTaskTypes); }
export function* watchActEngineers() { yield takeEvery(ACT_ENGINEERS, onActEngineers); }
export function* watchActDetail() { yield takeLatest(ACT_DETAIL, onActDetail); }
export function* watchActDetailList() { yield takeLatest(ACT_DETAIL_LIST, onActDetailList); }
export function* watchActDetailAdd() { yield takeLatest(ACT_DETAIL_ADD, onActDetailAdd); }
export function* watchActTaskStatus() { yield takeEvery(ACT_TASK_STATUS, onActTaskStatus); }
export function* watchActDeliveryPlanDetails() { yield takeLatest(ACT_DELIVERY_PLAN_DETAILS, onActDeliveryPlanDetails); }
export function* watchActMessageList() { yield takeLatest(ACT_MESSAGE_LIST, onActMessageList); }
export function* watchActMessageRead() { yield takeLatest(ACT_MESSAGE_READ, onActMessageRead); }

function* onActList(data) { try { const r = yield call(fetchApi, 'task/list', data.payload); yield put(ActListSuccess(r.data)); } catch (e) { yield put(ActListError(e)); } }

function* onActAdd(data) {
    try {
        const r = yield call(fetchApi, 'task/add', data.payload);
        if (r.data.status === true) { NotificationManager.success(r.data.message, 'Éxito', 3000, null, null, ''); }
        else { NotificationManager.error(r.data.message, 'Error', 3000, null, null, ''); }
        yield put(ActAddSuccess(r.data));
    } catch (e) { yield put(ActAddError(e)); NotificationManager.error('Error al crear tarea', 'Error', 3000, null, null, ''); }
}

function* onActGet(data) {
    try {
        const r = yield call(fetchApi, 'task/detail', data.payload);
        if (r.data && r.data.data) {
            const d = r.data.data;
            // Transformar datos para el formulario Edit
            const taskTypeData = d.id_task_type ? {
                key: d.id_task_type, label: d.task_type_name, value: d.task_type_name,
                requires_time: d.requires_time, requires_destination: d.requires_destination,
                requires_travel: d.requires_travel, requires_supplier: d.requires_supplier,
                hex_color: d.hex_color
            } : null;
            const selectedDestination = d.id_destination ? {
                key: d.id_destination, label: d.destination_name, value: d.destination_name
            } : null;
            const selectedEngineers = d.task_users || [];
            const selectedSuppliers = d.task_suppliers || [];
            const selectedSupplier = d.selectedSupplier || null;
            const editData = {
                id_task: d.id_task,
                id_task_type: d.id_task_type,
                taskTypeData: taskTypeData,
                id_destination: d.id_destination,
                selectedDestination: selectedDestination,
                id_supplier: d.id_supplier,
                selectedSupplier: selectedSupplier,
                id_task_status: d.id_task_status,
                task_status_name: d.task_status_name,
                task_status_code: d.task_status_code,
                description: d.description || '',
                start_date: d.start_date,
                end_date: d.end_date,
                users: selectedEngineers.map(u => u.key),
                selectedEngineers: selectedEngineers,
                suppliers_ids: selectedSuppliers.map(s => s.key),
                selectedSuppliers: selectedSuppliers,
                requires_travel: d.requires_travel === true
            };
            yield put(ActGetSuccess({ data: editData }));
        } else {
            yield put(ActGetError('No data'));
        }
    } catch (e) { yield put(ActGetError(e)); }
}

function* onActEdit(data) {
    try {
        const r = yield call(fetchApi, 'task/edit', data.payload);
        if (r.data.status === true) { NotificationManager.success(r.data.message, 'Éxito', 3000, null, null, ''); }
        else { NotificationManager.error(r.data.message, 'Error', 3000, null, null, ''); }
        yield put(ActEditSuccess(r.data));
    } catch (e) { yield put(ActEditError(e)); NotificationManager.error('Error al actualizar tarea', 'Error', 3000, null, null, ''); }
}

function* onActCalendar(data) { try { const r = yield call(fetchApi, 'task/calendar', data.payload || {}); yield put(ActCalendarSuccess(r.data)); } catch (e) { yield put(ActCalendarError(e)); } }
function* onActDestinations() { try { const r = yield call(fetchApi, 'search/task/destinations', {}); yield put(ActDestinationsSuccess(r.data)); } catch (e) { yield put(ActDestinationsError(e)); } }
function* onActSuppliers() { try { const r = yield call(fetchApi, 'search/task/suppliers', {}); yield put(ActSuppliersSuccess(r.data)); } catch (e) { yield put(ActSuppliersError(e)); } }
function* onActTaskTypes() { try { const r = yield call(fetchApi, 'search/task/taskTypes', {}); yield put(ActTaskTypesSuccess(r.data)); } catch (e) { yield put(ActTaskTypesError(e)); } }
function* onActEngineers() { try { const r = yield call(fetchApi, 'search/task/engineers', {}); yield put(ActEngineersSuccess(r.data)); } catch (e) { yield put(ActEngineersError(e)); } }

function* onActDetail(data) {
    try {
        const r = yield call(fetchApi, 'task/detail', data.payload);
        if (r.data && r.data.data) {
            yield put(ActDetailSuccess(r.data.data));
        } else {
            yield put(ActDetailError('No data'));
        }
    } catch (e) { yield put(ActDetailError(e)); }
}

function* onActDetailList(data) {
    try {
        const r = yield call(fetchApi, 'task/detail/list', data.payload);
        if (r.data && r.data.data) {
            yield put(ActDetailChatListSuccess(r.data.data));
        } else {
            yield put(ActDetailChatListError('No data'));
        }
    } catch (e) { yield put(ActDetailChatListError(e)); }
}

function* onActDetailAdd(data) {
    try {
        const r = yield call(fetchApi, 'task/detail/add', data.payload);
        if (r.data && r.data.status === true) {
            NotificationManager.success(r.data.message, 'Éxito', 3000, null, null, '');
        } else {
            NotificationManager.error(r.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(ActDetailChatAddSuccess(r.data));
    } catch (e) {
        yield put(ActDetailChatAddError(e));
        NotificationManager.error('Error al enviar mensaje', 'Error', 3000, null, null, '');
    }
}

function* onActTaskStatus() {
    try {
        const r = yield call(fetchApi, 'search/task/taskStatus', {});
        yield put(ActTaskStatusSuccess(r.data));
    } catch (e) { yield put(ActTaskStatusError(e)); }
}

function* onActDeliveryPlanDetails(data) {
    try {
        const r = yield call(fetchApi, 'task/deliveryPlanDetails', data.payload);
        if (r.data && r.data.data) {
            yield put(ActDeliveryPlanDetailsSuccess(r.data.data));
        } else {
            yield put(ActDeliveryPlanDetailsError('No data'));
        }
    } catch (e) { yield put(ActDeliveryPlanDetailsError(e)); }
}

function* onActMessageList(data) {
    try {
        const r = yield call(fetchApi, 'task/messages', data.payload);
        if (r.data && r.data.data) {
            yield put(ActMessageListSuccess(r.data));
        } else {
            yield put(ActMessageListError('No data'));
        }
    } catch (e) { yield put(ActMessageListError(e)); }
}

function* onActMessageRead(data) {
    try {
        yield call(fetchApi, 'task/messages/read', data.payload);
        yield put(ActMessageReadSuccess(data.payload));
        // Re-consultar la lista de mensajes para actualizar el badge
        const messageResponse = yield call(fetchApi, 'task/messages', { filters: {} });
        if (messageResponse.data && messageResponse.data.data) {
            yield put(ActMessageListSuccess(messageResponse.data));
        }
    } catch (e) { yield put(ActMessageReadError(e)); }
}

function* onActGenerateEquipmentUnit(data) {
    try {
        const r = yield call(fetchApi, 'equipment_unit/generate_by_task', data.payload);
        if (r.data.status === true) NotificationManager.success(r.data.message, 'Éxito', 3000, null, null, '');
        else if (r.data.status === 'error') NotificationManager.error(r.data.message, 'Error', 3000, null, null, '');
        yield put(ActGenerateEquipmentUnitSuccess(r.data));
    } catch (e) { yield put(ActGenerateEquipmentUnitError(e)); }
}

export function* watchActGenerateEquipmentUnit() { yield takeLatest(ACT_GENERATE_EQUIPMENT_UNIT, onActGenerateEquipmentUnit); }

export default function* rootSaga() {
    yield all([
        fork(watchActList), fork(watchActAdd), fork(watchActGet), fork(watchActEdit), fork(watchActCalendar),
        fork(watchActDestinations), fork(watchActSuppliers), fork(watchActTaskTypes), fork(watchActEngineers),
        fork(watchActDetail), fork(watchActDetailList), fork(watchActDetailAdd), fork(watchActTaskStatus),
        fork(watchActDeliveryPlanDetails),
        fork(watchActMessageList),
        fork(watchActMessageRead),
        fork(watchActGenerateEquipmentUnit)
    ]);
}
